import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useUserService, useErrorService } from '@abroad/components'
import API from '../../utils/API'
import AuthService from '../../utils/AuthService'
import { clearTravelDocumentPreviewUrlCache } from '../../utils/travelDocumentPreviewUrlCache'
import GlobalSearchInput from './GlobalSearchInput'

const getProfilePath = (user) => {
  if (user?.isAdmin && user?.isCoach) {
    return `/admin/${user?._id}/profile`
  }
  if (!user?.isAdmin && user?.isCoach) {
    return `/coach/${user?._id}/profile`
  }
  if (user?.isAdmin && !user?.isCoach) {
    return `/admin/profile/${user?._id}`
  }
  return '/'
}

const getAccountLabel = (user) => {
  if (user?.isAdmin) {
    return 'Admin'
  }
  if (user?.isCoach) {
    return 'Coach'
  }
  return user?.fullName || user?.firstName || 'Account'
}

const SidebarAccountFooter = () => {
  const { user, setUser } = useUserService()
  const history = useHistory()
  const Error = useErrorService()
  const [menuOpen, setMenuOpen] = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    if (!menuOpen) {
      return undefined
    }
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('mousedown', onDocClick)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [menuOpen])

  const onLogout = async () => {
    try {
      await API.ClientAPI.onboarding.logout()
      clearTravelDocumentPreviewUrlCache()
      setUser(null)
      AuthService.removeData()
      history.push('/client-redirect')
    } catch (e) {
      Error.showError(e)
    }
  }

  const profilePath = getProfilePath(user)

  return (
    <div className='experience-gnav-foot'>
      {(user?.isAdmin || user?.isCoach) && (
        <div className='experience-gnav-search'>
          <GlobalSearchInput />
        </div>
      )}
      <div className='experience-gnav-profile-wrap' ref={wrapRef}>
        <button
          type='button'
          className={`experience-gnav-profile${menuOpen ? ' open' : ''}`}
          aria-haspopup='true'
          aria-expanded={menuOpen}
          aria-label='User profile'
          onClick={() => setMenuOpen((open) => !open)}>
          <span className='experience-gnav-avatar' aria-hidden='true'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'>
              <circle
                cx='12'
                cy='8'
                r='3.4'
                stroke='#E6E4DF'
                strokeWidth='1.6'
              />
              <path
                d='M5.5 19.2c.9-3.2 3.4-5 6.5-5s5.6 1.8 6.5 5'
                stroke='#E6E4DF'
                strokeWidth='1.6'
                strokeLinecap='round'
              />
            </svg>
          </span>
          <span className='experience-gnav-who'>
            <b>{getAccountLabel(user)}</b>
            <small>Profile</small>
          </span>
        </button>
        {menuOpen ? (
          <div className='experience-gnav-menu' role='menu'>
            <h4>Account</h4>
            <Link
              to={profilePath}
              role='menuitem'
              className='experience-gnav-menu-item'
              onClick={() => setMenuOpen(false)}>
              <span>
                Profile
                <small>View and edit your account</small>
              </span>
            </Link>
            <div className='experience-gnav-menu-sep' />
            <button
              type='button'
              role='menuitem'
              className='experience-gnav-menu-item'
              onClick={() => {
                setMenuOpen(false)
                onLogout()
              }}>
              <span>
                Log out
                <small>Sign out of the Client Platform</small>
              </span>
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default SidebarAccountFooter
